import { Link } from "wouter";
import PowloLayout from "@/components/powlo/PowloLayout";
import Seo from "@/components/Seo";

export default function Network() {
  return (
    <PowloLayout>
      <Seo
        title="Installer network"
        description="How Powlo works with MCS-certified installers. Apply to join the network."
        path="/network"
      />
      <article className="mx-auto flex max-w-3xl flex-col gap-6 px-5 py-16 sm:px-8">
        <p className="text-sm font-bold tracking-widest text-powlo-indigo">INSTALLER NETWORK</p>
        <h1 className="m-0 font-powlo-display text-4xl font-bold tracking-tight sm:text-6xl">Local installers. One design.</h1>
        <p className="text-lg text-powlo-muted">
          Powlo designs the system and a certified installer fits it. Coverage and job volume are shown from live operations data inside the installer portal, not as marketing totals on this page.
        </p>
        <ul className="m-0 list-disc space-y-2 pl-5 text-powlo-muted">
          <li>MCS, RECC and TrustMark expectations stay with the installing firm.</li>
          <li>Jobs, surveys and packs are in the installer portal after you are approved.</li>
          <li>Customers see their own project, documents and deposit status.</li>
        </ul>
        <Link href="/installer/apply" className="w-fit rounded-full bg-powlo-ink px-6 py-3 font-bold text-white no-underline">
          Apply to install with Powlo
        </Link>
      </article>
    </PowloLayout>
  );
}
